var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        scroll: "keep",
        "auto-focus": "",
        "trap-focus": "",
        "destroy-on-hide": false,
      },
      on: {
        close: _vm.closeModal,
        "after-enter": function ($event) {
          return _vm.focusUsersInput()
        },
        "after-leave": function ($event) {
          return _vm.clearAttributes()
        },
      },
      model: {
        value: _vm.mutableShowModal,
        callback: function ($$v) {
          _vm.mutableShowModal = $$v
        },
        expression: "mutableShowModal",
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _vm._v(" Subir documentos a uno o más empleados"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Seleccionar por usuario, área o toda la organización"),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "box" }, [
            _c("div", { staticClass: "card-body mb-5" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        active: !this.isUsersEnabled,
                        multilined: "",
                        size: "is-large",
                        label:
                          _vm.Constants.STRINGS.TOOLTIPS
                            .MODAL_UPLOAD_OTRO_DOCUMENTO.USERS_DISABLED,
                        position: "is-right",
                      },
                    },
                    [
                      _c(
                        "label",
                        { class: this.isUsersEnabled ? "label" : "disabled" },
                        [
                          _c("i", { staticClass: "fas fa-users fa-fw" }),
                          _vm._v(" Seleccionar usuarios\n              "),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userInputForUsers,
                          expression: "userInputForUsers",
                        },
                      ],
                      ref: "inputUser",
                      staticClass: "input",
                      attrs: {
                        disabled: !this.isUsersEnabled,
                        type: "text",
                        placeholder: "Escriba el nombre o apellido del usuario",
                      },
                      domProps: { value: _vm.userInputForUsers },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.userInputForUsers = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "help" }, [
                      _vm._v(
                        "Sólo se pueden seleccionar usuarios con rol Usuario de Notificaciones"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [_vm._v(_vm._s(_vm.statusUsers))]),
                _vm._v(" "),
                _c(
                  "table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchResultUsers.length > 0,
                        expression: "searchResultUsers.length > 0",
                      },
                    ],
                    staticClass: "table is-bordered is-narrow is-marginless",
                  },
                  [
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.searchResultUsers.slice(0, _vm.FRONT_LIMIT),
                        function (result) {
                          return _c("tr", { key: result.index }, [
                            _c("td", [
                              _c("i", { staticClass: "fas fa-user" }),
                              _vm._v(" \n                    "),
                              _c(
                                "a",
                                {
                                  class: _vm.isUserAlreadySelected(result)
                                    ? "disabled"
                                    : "",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectUser(result)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(result.nombre) +
                                      " " +
                                      _vm._s(result.apellido)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.tieneRolLyris
                                ? _c("span", { staticClass: "disabled" }, [
                                    _vm._v(
                                      "organizacion_id: " +
                                        _vm._s(result.organizacion_id)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                this.isUsersEnabled
                  ? _c("label", { staticClass: "label" }, [
                      _vm._v(_vm._s(this.selectedUsersText)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-field",
                  {
                    staticClass: "is-flex is-justify-content-start",
                    attrs: { grouped: "", "group-multiline": "" },
                  },
                  _vm._l(this.selectedUsers, function (user) {
                    return _c(
                      "b-tag",
                      {
                        key: user.id,
                        staticClass: "m-0 mr-2",
                        attrs: {
                          type: "is-primary",
                          icon: "fas fa-user",
                          attached: "",
                          closable: "",
                        },
                        on: {
                          close: function ($event) {
                            return _vm.removeUser(user)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(user.apellido.toUpperCase()) +
                            ", " +
                            _vm._s(user.nombre) +
                            "\n              "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "box" }, [
            _c("div", { staticClass: "card-body mb-5" }, [
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        active: !this.isAreasEnabled,
                        multilined: "",
                        size: "is-large",
                        label:
                          _vm.Constants.STRINGS.TOOLTIPS
                            .MODAL_UPLOAD_OTRO_DOCUMENTO.AREAS_DISABLED,
                        position: "is-right",
                      },
                    },
                    [
                      _c(
                        "label",
                        { class: this.isAreasEnabled ? "label" : "disabled" },
                        [
                          _c("i", { staticClass: "fas fa-tags fa-fw" }),
                          _vm._v(" Seleccionar áreas\n              "),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userInputForAreas,
                          expression: "userInputForAreas",
                        },
                      ],
                      ref: "inputArea",
                      staticClass: "input",
                      attrs: {
                        disabled: !this.isAreasEnabled,
                        type: "text",
                        placeholder: "Escriba el nombre del área",
                      },
                      domProps: { value: _vm.userInputForAreas },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.userInputForAreas = $event.target.value
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [_vm._v(_vm._s(_vm.statusAreas))]),
                _vm._v(" "),
                _c(
                  "table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchResultAreas.length > 0,
                        expression: "searchResultAreas.length > 0",
                      },
                    ],
                    staticClass: "table is-narrow is-marginless",
                  },
                  [
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.searchResultAreas.slice(0, _vm.FRONT_LIMIT),
                        function (result) {
                          return _c("tr", { key: result.index }, [
                            _c("td", [
                              _c("i", { staticClass: "fas fa-tags" }),
                              _vm._v(" \n                    "),
                              _c(
                                "a",
                                {
                                  class: _vm.isAreaAlreadySelected(result)
                                    ? "disabled"
                                    : "",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectArea(result)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(result.id) +
                                      " - " +
                                      _vm._s(result.nombre)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.tieneRolLyris
                                ? _c("span", { staticClass: "disabled" }, [
                                    _vm._v(
                                      "organizacion_id: " +
                                        _vm._s(result.organizacion_id)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                this.isAreasEnabled
                  ? _c("label", { staticClass: "label" }, [
                      _vm._v(_vm._s(this.selectedAreasText)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-field",
                  {
                    staticClass: "is-flex is-justify-content-start",
                    attrs: { grouped: "", "group-multiline": "" },
                  },
                  _vm._l(this.selectedAreas, function (area) {
                    return _c(
                      "b-tag",
                      {
                        key: area.id,
                        staticClass: "m-0 mr-2",
                        attrs: {
                          type: "is-link",
                          icon: "fas fa-tag",
                          attached: "",
                          closable: "",
                        },
                        on: {
                          close: function ($event) {
                            return _vm.removeArea(area)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(area.id) +
                            " - " +
                            _vm._s(area.nombre.toUpperCase()) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "box" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              active: !this.isAllOrganizationEnabled,
                              multilined: "",
                              size: "is-large",
                              label:
                                _vm.Constants.STRINGS.TOOLTIPS
                                  .MODAL_UPLOAD_OTRO_DOCUMENTO
                                  .ALL_ORGANIZATION_DISABLED,
                            },
                          },
                          [
                            _c(
                              "b-switch",
                              {
                                attrs: {
                                  disabled: !this.isAllOrganizationEnabled,
                                  type: "is-danger",
                                  "left-label": true,
                                },
                                model: {
                                  value: _vm.allOrganization,
                                  callback: function ($$v) {
                                    _vm.allOrganization = $$v
                                  },
                                  expression: "allOrganization",
                                },
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    class: this.isAllOrganizationEnabled
                                      ? "label"
                                      : "disabled",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-building fa-fw",
                                    }),
                                    _vm._v(
                                      " Seleccionar todos los usuarios de la organización\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "box" }, [
            _c("div", { staticClass: "card-body mb-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label mb-1" }, [
                  _vm._v("Tipo de notificación:"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedType,
                            expression: "selectedType",
                          },
                        ],
                        attrs: { name: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.documentsTypes, function (type, i) {
                        return _c(
                          "option",
                          { key: i, domProps: { value: type.id } },
                          [_vm._v(_vm._s(type.nombre))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body mt-5 is-flex is-align-items-center" },
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    multilined: "",
                    size: "is-large",
                    label: this.getSignRequiredTooltipText,
                  },
                },
                [
                  _c(
                    "b-checkbox",
                    {
                      attrs: { disabled: _vm.allOrganization },
                      model: {
                        value: _vm.isSignRequired,
                        callback: function ($$v) {
                          _vm.isSignRequired = $$v
                        },
                        expression: "isSignRequired",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v("Los documentos requieren ser firmados"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isSignRequired && !this.isSimpleCase
                ? _c(
                    "div",
                    { staticClass: "ml-6 is-flex is-flex-direction-column" },
                    [
                      _c(
                        "b-radio",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            name: "is_global_document",
                            "native-value": "true",
                          },
                          model: {
                            value: _vm.isGlobalDocument,
                            callback: function ($$v) {
                              _vm.isGlobalDocument = $$v
                            },
                            expression: "isGlobalDocument",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Crear un único documento para todos los destinatarios (global)\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-radio",
                        {
                          attrs: {
                            name: "is_not_global_document",
                            "native-value": "false",
                          },
                          model: {
                            value: _vm.isGlobalDocument,
                            callback: function ($$v) {
                              _vm.isGlobalDocument = $$v
                            },
                            expression: "isGlobalDocument",
                          },
                        },
                        [
                          _vm._v(
                            "\n              Crear un documento por cada usuario destinatario\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c(
              "div",
              { staticClass: "buttons is-pulled-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "button is-outlined is-dark m-1",
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [_vm._v("Cancelar")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "button is-primary m-1",
                    attrs: { disabled: this.disableConfirmButton },
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v("Continuar")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }